__turbopack_context__.v({
  "imageFrame": "index-module-scss-module__owTpxa__imageFrame",
  "noImage": "index-module-scss-module__owTpxa__noImage",
});
